export const VENDORS_CHANGE_TRACKING = {
  searchName: {
    source: 'vendors.search.name',
    id: 12425,
  },
  searchServiceTypes: {
    source: 'vendors.search.service_types',
    id: 12426,
  },
  searchOperatingAddress: {
    source: 'vendors.search.operating_address',
    id: 12427,
  },
  searchOperatingCity: {
    source: 'vendors.search.operating_city',
    id: 12428,
  },
  searchOperatingState: {
    source: 'vendors.search.operating_state',
    id: 12429,
  },
  searchOperatingZip: {
    source: 'vendors.search.operating_zip',
    id: 12430,
  },
} as const;
